import { Component, OnInit, Input, DoCheck, Optional, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, ControlContainer, FormGroupDirective, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { TextBoxOptions } from '../../Shared/Models/TextBoxOptions';
import { InputType } from '../../Shared/Enums/InputType';
import { UtilityService } from '../../Shared/services/UtilityService';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { AutocompleteOptions } from '../../Shared/Models/AutocompleteOptions';
import { AutocompleteDTO } from '../../Shared/Models/AutocompleteDTO';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'BBSF-AutocompleteTextBox',
  templateUrl: './AutocompleteTextBox.component.html',
  styleUrls: ['./AutocompleteTextBox.component.scss']
})
export class AutocompleteTextBoxComponent implements OnInit {


  static controlContainerstatic = null;
  // tslint:disable-next-line: max-line-length
  constructor(private ErrorHandler: ErrorMassageValidation, private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public AutocompleteTextBoxControlHost: FormGroupDirective) {
    AutocompleteTextBoxComponent.controlContainerstatic = this.controlContainer;
  }
  @Input() group: FormGroup;
  @Input() options: AutocompleteOptions;
  @Output() OnChange = new EventEmitter();

  AutocompleteTextBoxControl: AbstractControl;
  Search: string = ''
  Key: string = ''
  QueryParam: string = 'query'
  Api: string = 'http';
  Value: string = 'value'
  NewSelectionValidationKey: string = '';
  markAllAsTouched: boolean = false;
  validationRules = [];
  validationRulesasync = [];


  ngOnInit() {

    UtilityService.isCreatedBefor = false
    this.group.addControl(this.options.Name, new FormControl(''));
    this.AutocompleteTextBoxControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);

    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);

    this.AutocompleteTextBoxControl.setValue(this.options.Value);


    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.validationRules.push(Validation.functionBody);
      }

    }



    if (this.options.IsRequired) {
      this.validationRules.push(Validators.required);
    }
    this.AutocompleteTextBoxControl.setValidators(this.validationRules);
    this.AutocompleteTextBoxControl.setAsyncValidators(this.validationRulesasync);
    if (this.options.IsDisabled) {
      this.AutocompleteTextBoxControl.disable();
    }

    if (this.options.Value != undefined && this.options.Value != null) {
      this.AutocompleteTextBoxControl.setValue(this.options.Value);
      this.AutocompleteTextBoxControl.updateValueAndValidity()
      this.Search = this.AutocompleteTextBoxControl.value.value
    }

    this.AutocompleteTextBoxControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })


  }


  ngAfterViewInit(): void {
    this.controlUtility.setAttributeForControl(this.options)
  }
  resetError = () => {
    UtilityService.RemoveGlobalError();
  }

  showGlobalError() {
    this.controlUtility.showGlobalError()
  }


  getErrorValidation(ErrorList) {

    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }

    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }

  copyInputMessage(inputElement) {
    this.controlUtility.CopyInputMessage(inputElement)
  }

  handleResultSelected(result) {
    console.log(result)
    console.log(this.AutocompleteTextBoxControl.value)

    if (this.AutocompleteTextBoxControl.value == '')
      result = ''

    if (typeof (result) == 'object' && typeof (this.AutocompleteTextBoxControl.value) == 'object') {
      if (result.value == this.AutocompleteTextBoxControl.value.value)
        return
    }
    else {
      if (result == this.AutocompleteTextBoxControl.value.value)
        return
    }

    if (this.options.AllowNewSelection == true) {

      if (typeof (result) == 'object') {

        let AutocompleteModel = new AutocompleteDTO();
        AutocompleteModel.key = result.key;
        AutocompleteModel.value = result.value;
        this.AutocompleteTextBoxControl.setValue(AutocompleteModel);
        this.AutocompleteTextBoxControl.updateValueAndValidity()

      }
      else {
        let AutocompleteModel = new AutocompleteDTO();
        AutocompleteModel.value = result;
        this.AutocompleteTextBoxControl.setValue(AutocompleteModel);
        this.AutocompleteTextBoxControl.updateValueAndValidity()

      }
    }
    else {

      if (this.AutocompleteTextBoxControl.value == result) {
        this.AutocompleteTextBoxControl.setErrors({ NewSelectionValidationKey: this.NewSelectionValidationKey });
        this.AutocompleteTextBoxControl.markAsTouched();
        this.AutocompleteTextBoxControl.invalid;
        return;
      }

      else {
        this.Search = result.value;
        let AutocompleteModel = new AutocompleteDTO();
        AutocompleteModel.key = result.key;
        AutocompleteModel.value = result.value;
        this.AutocompleteTextBoxControl.setValue(AutocompleteModel);
        this.AutocompleteTextBoxControl.updateValueAndValidity()
      }
    }

    this.Search = this.AutocompleteTextBoxControl.value.value
    this.OnChange.emit(this.AutocompleteTextBoxControl.value)


  }
  onTextChange(event) {
    this.Key = this.AutocompleteTextBoxControl.value;
  }

  //External Method
  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.AutocompleteTextBoxControl, this.validationRules, this.options)
  }
  //External Method
  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.AutocompleteTextBoxControl, this.validationRules, this.options)
  }

  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.AutocompleteTextBoxControl, this.validationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.AutocompleteTextBoxControl, this.validationRules, CustomValidation)
  }
  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.AutocompleteTextBoxControl)
  }

}


